import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import * as Sentry from '@sentry/react';
import styles from './styles';

const GOOGLE_CLIENT_ID = '384858041798-vabcn71h22fchf3043ogq60t7fb8ehso.apps.googleusercontent.com';

function LogIn(props) {
  const {
    openLoginDialog,
    onClose,
    handleLogin,
    email,
    password,
    setEmail,
    setPassword,
    openSignUpDialog,
    handleGoogleLogin,
  } = props;

  const handleEmailChange = (e) => setEmail(e.target.value);
  const handlePasswordChange = (e) => setPassword(e.target.value);

  const processGoogleLogin = (credentialResponse) => {
    console.log('processGoogleLogin');
    handleGoogleLogin(credentialResponse.credential);
  };

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Dialog
        open={openLoginDialog}
        onClose={onClose}
        onKeyUp={onKeyUp}
        aria-labelledby="login-dialog-title"
        BackdropComponent={() => <Box sx={styles.backdrop} />}
      >
        <DialogTitle id="login-dialog-title">
          <Box sx={styles.titleContainer}>
            <Typography variant="h6">Sign-in</Typography>
            <Typography variant="h6"> / </Typography>
            <Typography
              variant="h6"
              onClick={openSignUpDialog}
              sx={styles.clickableText}
            >
              Sign-up
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <TextField
            label="Email"
            type="text"
            value={email}
            onChange={handleEmailChange}
            fullWidth
            margin="normal"
            variant="outlined"
            required
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={handlePasswordChange}
            fullWidth
            margin="normal"
            variant="outlined"
          />

          <Box sx={styles.googleLoginContainer}>
            <GoogleLogin
              buttonText="Connect with Google"
              onSuccess={(credentialResponse) => processGoogleLogin(credentialResponse)}
              onError={() => {
                Sentry.captureMessage('Google OAuth login failed', 'warning');
              }}
            />
            <Typography variant="subtitle">(Only Existing Users)</Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={styles.actionContainer}>
          <Button autofocus onClick={handleLogin} sx={styles.actionButton}>
            Login
          </Button>
          <Button onClick={onClose} sx={styles.actionButton}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </GoogleOAuthProvider>
  );
}

LogIn.propTypes = {
  openLoginDialog: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired,
  handleGoogleLogin: PropTypes.func.isRequired,
  email: PropTypes.string,
  password: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  openSignUpDialog: PropTypes.func.isRequired,
};

LogIn.defaultProps = {
  email: null,
  password: null,
};

export default LogIn;
